import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<hr><div class=\"row fw-bold fs-5\" style=\"background-color:#f5f5f5;padding:10px;\"><div class=\"col-2\">Role</div><div class=\"col-2\">Group</div><div class=\"col-2\">IB Name</div><div class=\"col-2\">IB Account</div><div class=\"col-4\">Category</div></div>", 2)
const _hoisted_5 = {
  class: "row fs-5",
  style: {"padding":"10px"}
}
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, "--", -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"row fw-bold fs-5\" style=\"background-color:#f5f5f5;padding:10px;\"><div class=\"col-2\">Sales</div><div class=\"col-2\">Sales Account</div><div class=\"col-2\">Sales Code</div><div class=\"col-2\">Terms</div></div>", 1)
const _hoisted_12 = {
  class: "row fs-5",
  style: {"padding":"10px"}
}
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = { class: "col-2" }
const _hoisted_15 = { class: "col-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)

import { ref, onMounted } from "vue";
import AccountService from "../services/AccountService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRebateInfo',
  props: {
    accountDetails: {}
  },
  setup(__props: any) {

const props = __props;

const isLoading = ref(true);



const accountDetails = ref({});

// const pipCommissionDecision = ref({} as any);

onMounted(async () => {
  const res = await AccountService.queryAccounts({
    id: props.accountDetails?.id,
  });

  accountDetails.value = res.data[0];
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingRing)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("type.accountRole." + accountDetails.value.role)), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(accountDetails.value.agentAccount.group), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(accountDetails.value.agentAccount.name), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(accountDetails.value.agentAccount.uid) + "(" + _toDisplayString(accountDetails.value.agentAccount.id) + ") ", 1),
          _hoisted_10
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(accountDetails.value.salesAccount.name), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(accountDetails.value.salesAccount.uid) + "(" + _toDisplayString(accountDetails.value.salesAccount.id) + ") ", 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(accountDetails.value.salesAccount.code), 1),
          _hoisted_16
        ])
      ]))
}
}

})